import { render, staticRenderFns } from "./AreaAffectedAdd.vue?vue&type=template&id=094b2517&scoped=true&"
import script from "./AreaAffectedAdd.vue?vue&type=script&lang=js&"
export * from "./AreaAffectedAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094b2517",
  null
  
)

export default component.exports